import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import { useDispatch } from "react-redux";
const fmt = require("indian-number-format");

export default function ProfitLoss(props) {
  const dispatch = useDispatch();
  const socket = useContext(SocketContext);

  const { netnewqty, removeminus, symbol_id, item, total } = props;

  const [pf, setpf] = useState(0);

  // ✅ Socket setup
  useEffect(() => {
    if (!socket || !symbol_id) return;

    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);

    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id]);

  // ✅ Profit/Loss calculation (with conditional dollar_rate)
  const trade = (data) => {
    if (!data) return;
    const rupee_dollar = item.rupee_dollar; // normalize case
    const type = (item.type || "").toLowerCase(); // normalize case
    const isDollarBased =
      type === "comex_future" ||
      type === "forex_future" ||
      type === "crypto_future" ||
      type === "us_stock" ||
      type === "index" ||
      type === "dgcx";

    const drate = isDollarBased ? parseFloat(item.dollar_rate) || 1 : 1;
    let profitLoss = 0;

    if (netnewqty > 0) {
      // 🟢 Buy position
      const bid = parseFloat(data.Bid) || 0;
      const ltp = parseFloat(data.LTP) || 0;
      const buyPrice = parseFloat(item.buyavg) || 0;
      const price = bid > 0 ? bid : ltp;
      profitLoss = (price - buyPrice) * parseFloat(removeminus);
      if (rupee_dollar === 0) {
        profitLoss = (price - buyPrice) * parseFloat(removeminus) * drate;
      }
    } else if (netnewqty < 0) {
      // 🔴 Sell position
      const ask = parseFloat(data.Ask) || 0;
      const ltp = parseFloat(data.LTP) || 0;
      const sellPrice = parseFloat(item.sellavg) || 0;
      const price = ask > 0 ? ask : ltp;
      profitLoss = (sellPrice - price) * parseFloat(removeminus);

      if (rupee_dollar === 0) {
        profitLoss = (sellPrice - price) * parseFloat(removeminus) * drate;
      }
    }

    setpf(profitLoss.toFixed(0));
  };

  // ✅ Dispatch PF updates to Redux
  useEffect(() => {
    if (!item?.symbol_id) return;
    dispatch({
      type: "PF",
      symbol_id: item.symbol_id,
      pf,
      total,
    });
  }, [dispatch, pf, item?.symbol_id, total]);

  return (
    <div className={`menuBuyPrice ${pf > 0 ? "buytext" : "selltext"}`}>
      {fmt.format(pf)}
    </div>
  );
}
